var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownLoad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "01 align center"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.02178 13.1667C8.28452 13.1671 8.54476 13.1156 8.78753 13.0152C9.03031 12.9147 9.25084 12.7673 9.43645 12.5813L12.0491 9.96667L11.1065 9.02667L8.68445 11.4493L8.66712 0.5H7.33378L7.35112 11.4387L4.93778 9.02533L3.99512 9.96667L6.60778 12.5793C6.79317 12.7655 7.01353 12.9133 7.25618 13.0141C7.49884 13.1149 7.75902 13.1667 8.02178 13.1667Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.6667 11.1669V14.5002C14.6667 14.677 14.5964 14.8466 14.4714 14.9716C14.3464 15.0966 14.1768 15.1669 14 15.1669H2C1.82319 15.1669 1.65362 15.0966 1.5286 14.9716C1.40357 14.8466 1.33333 14.677 1.33333 14.5002V11.1669H0V14.5002C0 15.0306 0.210714 15.5393 0.585786 15.9144C0.960859 16.2895 1.46957 16.5002 2 16.5002H14C14.5304 16.5002 15.0391 16.2895 15.4142 15.9144C15.7893 15.5393 16 15.0306 16 14.5002V11.1669H14.6667Z",
    fill: "#231F20"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownLoad);
export default __webpack_public_path__ + "static/media/downLoad.5732b982ad03cc54d10f1d055d5ff1cc.svg";
export { ForwardRef as ReactComponent };